/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import MDBox from "dashboard-template/components/MDBox";
import MDTypography from "dashboard-template/components/MDTypography";
import { ErrorMessage, Field, FieldAttributes } from "formik";
import { forwardRef } from "react";
import MuiCheckbox, { CheckboxProps } from "./Checkbox";

/**
 * Props for FormInputCheckbox - combines Formik Field attributes with Checkbox props.
 * @typedef {FieldAttributes<CheckboxProps>} FormInputCheckboxProps
 */
export type FormInputCheckboxProps = FieldAttributes<CheckboxProps>;

/**
 * Formik-integrated checkbox field with error display.
 * 
 * Features:
 * - Formik Field integration
 * - Automatic error message display
 * - Standard variant styling
 * - Checkbox with label
 * - Error state visualization
 * 
 * @param name - Formik field name for binding
 * @param props - Additional checkbox properties
 * @returns Formik checkbox field with error handling
 */
const FormInputCheckbox = forwardRef(({ name, ...props }: FormInputCheckboxProps, ref) => {
  return (
    <MDBox className="FormInputCheckbox-margin-top-small">
      <Field variant="standard" name={name} as={MuiCheckbox} {...props} ref={ref} />
      <MDBox className="FormInputCheckbox-margin-top-small">
        <MDTypography component="div" variant="caption" color="error" fontWeight="regular">
          {(<ErrorMessage name={name} />) as any}
        </MDTypography>
      </MDBox>
    </MDBox>
  );
});

export default FormInputCheckbox;
